/* Italian Secret, 2026-09-28: Signed-in offer eligibility and a useful alternative for unavailable offers. */
(() => {
  'use strict';
  const element = document.getElementById('italiansecret-sample-config');
  if (!element) return;
  const settings = JSON.parse(element.textContent);
  const content = document.getElementById('italiansecret-offer-content');
  const alternative = document.getElementById('sample-offer-unavailable');
  const status = document.getElementById('sample-access-status');
  function show(eligible) {
    if (content) content.hidden = !eligible;
    if (alternative) alternative.hidden = eligible;
    if (status) status.hidden = true;
    document.querySelectorAll('.sample-offer-link').forEach(link => { link.hidden = !eligible; });
  }
  // Owner correction, 2026-10-07: the landing stays visible; redemption remains server-controlled.
  if (settings.deferEligibility) { show(true); return; }
  window.addEventListener('italiansecret:offer-unavailable', () => show(false));
  if (!settings.audienceAllowed) { show(false); return; }
  if (!settings.authenticated) { show(true); return; }
  async function check() {
    try {
      const url = new URL(settings.eligibilityUrl, location.origin);
      if (url.origin !== location.origin) throw Error('Invalid eligibility endpoint');
      const response = await fetch(url, {method:'POST',credentials:'same-origin',signal:AbortSignal.timeout(15000),
        headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
        body:new URLSearchParams({payload:JSON.stringify({campaignKey:settings.campaignKey,...(/^[A-Za-z0-9_-]{32}$/.test(window.PIZZA_CONFIG?.publicId||'')?{publicId:window.PIZZA_CONFIG.publicId}:{})})})});
      if (!response.ok) throw Error('Offer check unavailable');
      const result = await response.json();
      if (typeof result.eligible !== 'boolean') throw Error('Invalid offer response');
      show(result.eligible);
    } catch {
      if (!status) return;
      status.hidden = false;
      status.replaceChildren(document.createTextNode('We couldn’t check this offer right now. '));
      const retry = document.createElement('button');
      retry.type = 'button'; retry.className = 'back-button'; retry.textContent = 'Try again';
      retry.addEventListener('click', () => { retry.disabled = true; void check(); });
      status.append(retry);
    }
  }
  if (settings.managedCampaignUrl) {
    window.PizzaConfigReady.then(() => check()).catch(() => {});
  } else void check();
})();
